import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';
import { UserService } from './services/user.service';


@Component({
  selector: 'app-user-select-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule],
  template: `
      <h2 mat-dialog-title>Select a User</h2>
      <mat-dialog-content>
          <div class="user-list">
              @for (user of users; track user.name) {
                  @if (isCurrent(user)) {
                      <button mat-raised-button color="primary" (click)="selectUser(user)" class="user-btn">
                          {{ user.name }}
                      </button>
                  } @else {
                      <button mat-stroked-button (click)="selectUser(user)" class="user-btn">
                          {{ user.name }}
                      </button>
                  }

              }
          </div>
      </mat-dialog-content>
      <mat-dialog-actions align="end">
          <button mat-button (click)="close()">Cancel</button>
      </mat-dialog-actions>
  `,
  styles: [`
    .user-list {
      display: flex;
      flex-direction: column;
      gap: .5rem;
    }

    .user-btn {
      text-align: left;
    }
  `]
})
export class UserSelectDialogComponent {
  public currentUser;
  public users = [
    {
      name: 'Sarah Johnson',
      full_name: 'Sarah Johnson',
      'X-Pomerium-Claim-Sub': 'sarah-researcher-004',
      'X-Pomerium-Claim-Email': 'sarah.johnson@bcforestry.ca',
      'X-Pomerium-Claim-Name': 'Sarah Johnson',
      'X-Pomerium-Claim-Iss': 'https://auth.example.com/realms/bc-forestry',
      'X-Pomerium-Claim-Groups': 'research-team'
    },
    {
      name: 'Bob Williams',
      full_name: 'Bob Williams',
      'X-Pomerium-Claim-Sub': 'bob-scientist-002',
      'X-Pomerium-Claim-Email': 'bob.williams@bcforestry.ca',
      'X-Pomerium-Claim-Name': 'Bob Williams',
      'X-Pomerium-Claim-Iss': 'https://auth.example.com/realms/bc-forestry',
      'X-Pomerium-Claim-Groups': 'research-team'
    },
    {
      name: 'Alice Chen',
      full_name: 'Alice Chen',
      'X-Pomerium-Claim-Sub': 'alice-forest-manager-001',
      'X-Pomerium-Claim-Email': 'alice.chen@bcforestry.ca',
      'X-Pomerium-Claim-Name': 'Alice Chen',
      'X-Pomerium-Claim-Iss': 'https://auth.example.com/realms/bc-forestry',
      'X-Pomerium-Claim-Groups': 'kamloops-region'
    }
  ];

  constructor(
    public dialogRef: MatDialogRef<UserSelectDialogComponent>,
    public userService: UserService
  ) {
    console.log(userService.authUser, JSON.parse(localStorage.getItem('pomeriumAuth')), this.users[0]);
    this.currentUser = userService.authUser || JSON.parse(localStorage.getItem('pomeriumAuth')) || this.users[0];
  }

  isCurrent(user): boolean {
    if (!this.currentUser || !user) return false;
    return  user.name === this.currentUser.name;
  }


  selectUser(user) {
    this.userService.authUser = user;
    localStorage.setItem('pomeriumAuth', JSON.stringify(user));
    this.dialogRef.close(user);
  }

  close() {
    this.dialogRef.close();
  }
}
